import Service from '../Service'
import AuthService from '../AuthService'

const Research = {
    getResearchList(page) {
        return AuthService.get("/api/show-paginate-all-research?page=" + page).then(res => {
            return res;
        });
    },
    getNewResearchList(page) {
        return AuthService.get("/api/show-paginate-new-research?page=" + page).then(res => {
            return res;
        });
    },
    getVerifiedResearchList(searchData) {
        return AuthService.get('/api/get-paginate-verified-research?page='
            + searchData.page +
            '&researchCode=' + searchData.researchCode +
            '&researcherName=' + searchData.researcherName +
            '&initialNumber=' + searchData.initialNumber +
            '&considerType=' + searchData.considerType +
            '&isResubmission=' + searchData.isResubmission +
            '&startDate=' + searchData.startDate +
            '&endDate=' + searchData.endDate +
            '&researchName=' + searchData.researchName).then(res => {
                return res;
            });
    },
    getPaginateResearchByReviewerID(page, id) {
        return AuthService.get(`/api/get-paginate-research-by-reviewerID/${id}?page=` + page).then(res => {
            return res;
        });
    },
    getPaginateResearchByReviewerIDFilter(page, id, considerType, reviewType) {
        return AuthService.get('/api/get-paginate-research-by-reviewerID-filter?page=' + page + '&reviewerID=' + id + '&considerType=' + considerType + '&reviewType=' + reviewType).then(res => {
            return res;
        });
    },
    getPaginatePostApproveByReviewerIDFilter(page, id, filter) {
        return AuthService.get('/api/get-paginate-post-approve-by-reviewerID-filter?page=' + page + '&reviewerID=' + id + '&filter=' + filter).then(res => {
            return res;
        });
    },
    getRF(page, id, filter) {
        return AuthService.get('/api/get-paginate-post-approve-by-reviewerID-filter?page=' + page + '&reviewerID=' + id + '&filter=' + filter).then(res => {
            return res;
        });
    },
    getRFApprove(page, filter, researcherName, researchCode) {
        return AuthService.get('/api/show-paginate-rf-can-approve?page=' + page + '&filter=' + filter + "&researcherName=" + researcherName + "&researchCode=" + researchCode).then(res => {
            return res;
        });
    },
    saveResearchVerify(data) {
        return AuthService.post("/api/research-verify", data).then(res => {
            return res;
        });
    },

    saveChooseReviewer(data) {
        let formData = new FormData();
        formData.append('meetingID', data.meetingID);
        formData.append('researchID', data.researchID);
        formData.append('considerType', data.considerType);
        formData.append('reviewerDatas', JSON.stringify(data.reviewerDatas));
        return AuthService.post("/api/choose-reviewer", formData, {
            headers: {
                "Content-Type": 'multipart/form-data',
            }
        }).then(res => {
            return res;
        });
    },
    updatetypeConsideration(data) {
        return AuthService.put(`/api/choose-consider-type/${data.researchID}`, data).then(res => {
            return res;
        });
    },
    researchReceive(id) {
        return AuthService.put(`/api/research-receive/${id}`).then(res => {
            return res;
        });
    },
    getResearchVerify(id) {
        return AuthService.get(`/api/research-verify/${id}`).then(res => {
            return res;
        });
    },
    showChooseReviewer(id) {
        return AuthService.get(`/api/show-choose-reviewer/${id}`).then(res => {
            return res;
        });
    },
    getSubcommittee(data) {
        return AuthService.get(`/api/get-all-reviewer?page=${data.page}&keyword=${data.keyword === null ? '' : data.keyword}`).then(res => {
            return res;
        });
    },
    getInitialResearch() {
        return AuthService.get("/api/get-initial-research").then(res => {
            return res;
        });
    },
    getInitialResearchList() {
        return AuthService.get("/api/get-initial-research-post").then(res => {
            return res;
        });
    },
    showReviewerSelect(id) {
        return AuthService.get(`/api/show-reviewer-for-select/${id}`).then(res => {
            return res;
        });
    },
    showReviewerSelectAll() {
        return AuthService.get(`/api/show-all-reviewer-for-select`).then(res => {
            return res;
        });
    },
    deleteResearchVerify(id) {
        return AuthService.delete(`/api/research-verify/${id}`).then(res => {
            return res;
        });
    },
    updateConsiderResult(data) {
        return AuthService.post("/api/update-consider-result", data).then(res => {
            return res;
        });
    },
    previewCOA(data) {
        return AuthService.post(`/api/research-approve-preview/${data.id}`, data).then(res => {
            return res;
        });
    },
    cancelResearchCode(data) {
        return AuthService.post(`/api/cancel-research-code`, data).then(res => {
            return res;
        })
    },
    // previewCOA(data) {
    //     return Service.post(`/api/research-approve-preview/${data.id}`, data,{
    //         headers: {
    //             "Access-Control-Allow-Origin": '*',
    //         }
    //     }).then(res => {
    //         return res;
    //     });
    // },
    getPaginateResearchFilter(searchData) {
        return AuthService.get('/api/show-paginate-research-can-approve?page='
            + searchData.page +
            '&researchCode=' + searchData.researchCode +
            '&researcherName=' + searchData.researcherName +
            '&initialNumber=' + searchData.initialNumber +
            '&considerType=' + searchData.considerType +
            '&isResubmission=' + searchData.isResubmission +
            '&startDate=' + searchData.startDate +
            '&endDate=' + searchData.endDate +
            '&researchName=' + searchData.researchName
        ).then(res => {
            return res;
        });
    },
    getResearch(id) {
        return AuthService.get(`/api/show-research-for-view/${id}`).then(res => {
            return res;
        });
    },
    searchResearchCode(searchData) {
        if (searchData.status === undefined) {
            searchData.status = '';
        }
        if (searchData.considerationType === undefined) {
            searchData.considerationType = '';
        }
        return AuthService.get('/api/search-by-researchCode?page=' + searchData.page +
            '&researchCode=' + searchData.researchCode +
            '&researcherName=' + searchData.researcherName +
            '&initialNumber=' + searchData.initialNumber +
            '&status=' + searchData.status +
            '&considerationType=' + searchData.considerationType +
            '&isResubmission=' + searchData.isResubmission +
            '&startDate=' + searchData.startDate +
            '&endDate=' + searchData.endDate +
            '&researchName=' + searchData.researchName +
            '&ymidname=' + searchData.ymidname +
            '&checkPaginate=' + searchData.checkPaginate
        ).then(res => {
            return res;
        });
    },

    sendReviewerMail(researchID) {
        return AuthService.post(`/api/choose-reviewer-send-mail/${researchID}`).then(res => {
            return res;
        });
    },

    getFormResearch1(id) {
        return AuthService.get(`/api/show-research/${id}`).then(res => res)
    },

    getResearchLog(id) {
        return AuthService.get(`/api/show-research-log/${id}`).then(res => res)
    },

    getFormResearch2(id) {
        return AuthService.get(`/api/show-research/${id}`).then(res => res)
    },
    sendApproveMail(data) {
        return AuthService.post(`/api/send-approve-mail-pre/${data.researchID}`, data).then(res => res)
    },
    previewApproveMail(data) {
        return AuthService.post(`/api/preview-approve-email/${data.researchID}`, data).then(res => res)
    },
    previewConsiderResultMail(data) {
        return AuthService.post(`/api/preview-consider-result-email/${data.id}`, data).then(res => res)
    },
    researchEmailResend(data) {
        return AuthService.post(`/api/research-email-resend/${data.id}`, data).then(res => res)
    },
    sendPostApproveMail(data) {
        return AuthService.post(`/api/send-approve-mail-post/${data.researchID}`, data).then(res => res)
    },
    getResearchHistory(data) {
        return AuthService.get(`/api/get-research-history?researchID=` + data.researchID).then(res => res)
    },
    getCancelResearch(page) {
        return AuthService.get('/api/get-cancel-research?page=' + page.page +
            '&researchCode=' + page.researchCode +
            '&researcherName=' + page.researcherName +
            '&initialNumber=' + page.initialNumber +
            '&status=' + page.status +
            '&considerationType=' + page.considerationType +
            '&isResubmission=' + page.isResubmission +
            '&startDate=' + page.startDate +
            '&endDate=' + page.endDate +
            '&researchName=' + page.researchName
        ).then(res => {
            return res;
        });
    },
    acceptCancelResearch(data) {
        return Service.get('/api/acceptCancel?id=' + data.id);
    },
    getSummaryFile(id){
        return AuthService.get(`/api/get-research-summary-file/${id}`);
    }

}

export default Research;
